import React, { useState, Fragment, useEffect } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { NavLink, Link, useHistory, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  AppBar,
  Toolbar,
  IconButton,
  Tooltip,
  Button,
  Avatar,
  Box,
  Badge,
  Menu,
  List,
  ListItem,
  ListItemButton,
  Drawer,
  Divider,
  Grid,
  useTheme,
  useMediaQuery,
  Switch,
  ListSubheader,
  ListItemIcon,
  ListItemText,
  Collapse,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import grey from "@mui/material/colors/grey";
import MenuOpenRoundedIcon from "@mui/icons-material/MenuOpenRounded";
import AppsIcon from "@mui/icons-material/Apps";
import SecurityIcon from "@mui/icons-material/Security";
import InfoIcon from "@mui/icons-material/Info";
import TuneIcon from "@mui/icons-material/Tune";
import CircleIcon from "@mui/icons-material/Circle";
import WbSunnyIcon from "@mui/icons-material/WbSunny";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import { makeStyles, withStyles } from "@mui/styles";
import MenuIcon from "@mui/icons-material/Menu";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import menuItems from "../config/configureMenu";
import AboutDialog from "./AboutDialog";
// import RMSTopbarShareDialog from "./topbarShareDialog";
// import RMSConfirmationModal from "./RMSModals/RMSConfirmationModal";
// import UnreadBulletins from "./UnreadBulletins";
import IconAms from "../assets/images/icon-AMS.svg";
import { colors } from "../config/colorVariables";
import { setNavigationDrawerMobileState } from "../reducers/UiReducer";
import { setMode } from "../reducers/ThemeReducer";
import {
  authorizeExternalApp,
  setUserAuthenticated,
  setUserAgency,
} from "../reducers/UserReducer";
import { getApiVer } from "../reducers/AppInfoReducer";
import store from "../config/configureStore";
import {
  Category,
  ExpandLess,
  ExpandMore,
  LocalOffer,
  SettingsSuggest,
} from "@mui/icons-material";
import {
  PATH_TAGS,
  PATH_CODE_SETTING,
  PATH_CUSTOM_IDS,
  PATH_SECURITY,
  PATH_HOME,
} from "../utils/routeConstants";
import { fetchAgencies } from "../reducers/PtsAgencyReducer";
import { editPathMap } from "../utils/routeConstants";
import { getDictionaries, getUsers } from "../reducers/DictionaryReducer";
import {
  getAccessPermission,
  getUserPermissions,
} from "../reducers/PermissionsReducer";
import { getService } from "../reducers/service";
import IconCad from "../assets/images/icon-CAD.svg";
import iconRms from "../assets/images/icon-RMS.svg";
import IconMobile from "../assets/images/icon-MOBILE.svg";
import IconAnalytics from "../assets/images/icon-ANALYTICS.png";
import IconArchive from "../assets/images/icon-ARC.png";
import IconSetting from "../assets/images/icon-SETTING.png";
import { serviceNames } from "../utils/constants";
import whiteLogo from '../assets/images/PTS-logo-white.png';
import { getPasswordValidation, getSessionSettings } from '../reducers/ConfigReducer';

const drawerWidth = 220;
const drawerHeight = 50;

const useStyles = makeStyles((theme) => ({
  wrapper: {
    display: "flex",
    flexDirection: "row",
    alignSelf: "center",
    justifyContent: "space-between",
    width: "100%",
  },
  leftMenu: {
    display: "flex",
    flex: 1,
    color: theme.palette.colors.text1,
    paddingTop: "2px 0px",
  },
  items: {
    color: "white",
    padding: "0px",
    fontSize: "17px",
  },
  drawerItems: {
    color: theme.palette.bgElements,
    padding: "0px",
    fontSize: "17px",
  },
  itemsBtn: {
    color: theme.palette.colors.label,
    padding: "7px 16px",
  },
  propertyBtn: {
    color: theme.palette.colors.label,
    paddingTop: "7px",
    paddingBottom: "7px",
    paddingLeft: "20px",
  },
  label: {
    flexDirection: "column",
  },
  drawerItemsBtn: {
    color: `${theme.palette.colors.label} !important`,
    fontSize: "17px",
    padding: "10px 40px",
  },
  rightMenu: {
    alignSelf: "center",
    paddingTop: "2px 0px",
    display: "flex",
    alignItems: "center",
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: theme.palette.bgElements,
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  drawer: {
    [theme.breakpoints.up("sm")]: {
      width: drawerWidth,
      flexShrink: 0,
    },
    zIndex: 98,
  },
  drawerPaper: {
    width: drawerWidth,
    padding: "0px 6px",
  },
  toolbar: {
    height: drawerHeight,
    backgroundColor: theme.palette.bgElements,
  },
  btn: {
    width: "85px",
    height: "60px",
    border: "3px solid rgba(1, 83, 163, 0.5) !important",
    color: "white",
  },
  btnLabel: {},
  avatar: {
    position: "relative",
    "& i": {
      position: "absolute",
      bottom: -18,
      left: -30,
      right: -30,
      fontSize: 11,
      fontWeight: 600,
      color: theme.palette.primary.main,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      fontStyle: "normal",
      textAlign: "center",
    },
  },
  activeNav: {
    color: "red",
    "& > button": {
      fontWeight: 600,
      color: grey[200],
    },
  },
  locationSearchMenu: {
    "& svg": {
      marginRight: theme.spacing(1),
      fontSize: 16,
      opacity: 0.25,
    },
    "& a": {
      color: theme.palette.colorFont,
    },
  },
  searchMenu: {
    display: "flex",
    "& h5": {
      paddingLeft: "30px",
    },
    "& svg": {
      marginRight: theme.spacing(1),
      fontSize: 16,
      opacity: 0.25,
    },
    "& a": {
      color: theme.palette.colorFont,
    },
  },
  fullWidthMenu: {
    zIndex: 2,
    position: "absolute",
    top: 70,
    left: 0,
    right: 0,
    width: "100%",
    padding: `${theme.spacing(3)}px ${theme.spacing(2)}px ${theme.spacing(
      2
    )}px`,
  },
  locationsMenuWrap: {
    position: "absolute",
    top: 70,
    left: "22rem",
    right: 0,
    bottom: 0,
    width: "10%",
    height: "100%",
    zIndex: 2,
  },
  peopleMenuWrap: {
    position: "absolute",
    top: 70,
    left: "12rem",
    right: 0,
    bottom: 0,
    width: "10%",
    height: "100%",
    zIndex: 2,
  },
  fwMenuWrap: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: "100%",
    height: "100%",
    zIndex: 2,
  },
  logoText: {
    color: theme.palette.bgElements,
  },
  propertyItemIcon: {
    color: colors.defaultBlueDarker2,
    fontSize: "10px !important",
  },
  outlined: {
    color: theme.palette.colors.label,
  },
  propertyItemLabel: {
    color: theme.palette.colorFont,
    paddingLeft: "5px",
  },
  listItemActive: {
    "&.active": {
      color: theme.palette.colors.text1,
      fontWeight: 900,
      textDecoration: "underline",
      textDecorationColor: theme.palette.colors.text1,
      textDecorationThickness: "3px",
      textUnderlineOffset: "10px",
    },
  },
  subMenuListItemActive: {
    padding: "2px 3px !important",
    "&.active": {
      color: theme.palette.topBar.submenu,
      fontWeight: 900,
    },
  },
  disabledDrawer: {
    color: theme.palette.bgElements,
    padding: "0px",
    fontSize: "17px",
    cursor: "not-allowed !important",
  },
  disabledDrawerItems: {
    fontWeight: "100",
    fontSize: "17px",
    padding: "10px 40px",
    // color: 'currentColor',
    cursor: "not-allowed !important",
    opacity: 0.5,
    // textDecoration: 'none',
  },
  searchMenuItem: {
    width: "100%",
  },
  subMenu: {
    position: "absolute",
    top: "calc(100% + 8px)",
    // left: 0,
    zIndex: 1000,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[3],
    minWidth: "200px",
  },
   logo: {
    width: 150,
    height: 48,
    backgroundColor: theme.palette.colors.text1,
    WebkitMask: `url(${whiteLogo}) no-repeat center / contain`,
    mask: `url(${whiteLogo}) no-repeat center / contain`,
  },
}));

const UserBadge = withStyles({
  badge: {
    boxShadow: "0 0 0 2px #fff",
    "&::after": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      animation: "$ripple 1.2s infinite ease-in-out",
      border: "1px solid currentColor",
      content: '""',
    },
  },
  "@keyframes ripple": {
    "0%": {
      transform: "scale(.8)",
      opacity: 1,
    },
    "100%": {
      transform: "scale(2.4)",
      opacity: 0,
    },
  },
})(Badge);

const NavBase = React.forwardRef((props, ref) => (
  <NavLink ref={ref} {...props} />
));

const TopBar = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("lg"));

  const {
    user,
    setMode,
    network,
    themeMode,
    setUserAuthenticated,
    navigationDrawerMobileState,
    setNavigationDrawerMobileState,
    agencies,
    wsClient,
  } = props;

  const [anchorEl, setAnchorEl] = useState(null);
  const userAgency = useSelector((s) => s.user.userAgency);
  const [displayAbout, setDisplayAbout] = useState(false);
  const [userName, setUserName] = useState("");
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [openAppSubmenu, setOpenAppSubmenu] = useState(false);
  const [openOptionSubmenu, setOpenOptionSubmenu] = useState(false);
  const [openTrainingSubmenu, setOpenTrainingSubmenu] = useState({});
  const [agenciesList, setAgenciesList] = useState([]);
  const [currentUserAgency, setCurrentUserAgency] = useState("");
  const [isInsideEditPage, setIsInsideEditPage] = useState(false);
  const [rmsLink, setRMSLink] = useState(null);
  const [cadLink, setCADLink] = useState(null);
  const [mobileLink, setMobileLink] = useState(null);
  const [settingLink, setSettingLink] = useState(null);
  const [analyticsLink, setAnalyticsLink] = useState(null);
  const [archiveLink, setArchiveLink] = useState(null);
  const isPermissionLoaded = store.store.getState().permissions.loaded;
  const rmsPermission =
    isPermissionLoaded && getAccessPermission("modules", "RMS", "any");
  const canReadRMSPermission = rmsPermission?.Read;
  const cadPermission =
    isPermissionLoaded && getAccessPermission("modules", "CAD", "any");
  const canReadCadPermission = cadPermission?.Read;
  const analyticsPermission =
    isPermissionLoaded && getAccessPermission("modules", "Analytics", "any");
  const canReadAnalyticsPermission = analyticsPermission?.Read;

  const mobilePermission =
    isPermissionLoaded && getAccessPermission("modules", "Mobile");
  const canReadMobilePermission = mobilePermission?.Read;

  const settingPermission =
    isPermissionLoaded && getAccessPermission("modules", "Settings");
  const canReadSetingsPermission = settingPermission?.Read;

  const archivePermission =
    isPermissionLoaded && getAccessPermission("modules", "Archive");
  const canReadArchivePermission = archivePermission?.Read;

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    dispatch(getApiVer());
    getAllUrls();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wsClient]);

  useEffect(() => {
    if (user.userData && user?.userData?.user) {
      let name = user?.userData?.user.Username;
      if (name !== userName) setUserName(name);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  useEffect(() => {
    dispatch(fetchAgencies());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wsClient, user]);

  useEffect(() => {
    setCurrentUserAgency(user.userAgency || "");
  }, [wsClient, user.userAgency]);

  useEffect(() => {
    setAgenciesList(agencies);
  }, [agencies]);

  const changeUserAgency = (e) => {
    dispatch(setUserAgency(e.target.value));
    setCurrentUserAgency(e.target.value);
    props.setUserAgency(e.target.value);
  };

  useEffect(() => {
    const isEditPage = editPathMap.some((editPath) =>
      location.pathname.startsWith(editPath)
    );

    if (isEditPage && !isInsideEditPage) {
      setIsInsideEditPage(true);
    }

    if (!isEditPage && isInsideEditPage) {
      setIsInsideEditPage(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  const handleOptionClick = () => {
    setOpenOptionSubmenu((prev) => !prev);
  };

  const getAllUrls = async () => {
    const service = getService(serviceNames.CDR);

    const results = await Promise.all([
      service.get({ Path: "Settings.Link.RMS", CDRKey: "RMSLink" }),
      service.get({ Path: "Settings.Link.CAD", CDRKey: "CADLink" }),
      service.get({ Path: "Settings.Link.Mobile", CDRKey: "MobileLink" }),
      service.get({ Path: "Settings.Link.Setting", CDRKey: "SettingLink" }),
      service.get({ Path: "Settings.Link.Analytics", CDRKey: "AnalyticsLink" }),
      service.get({ Path: "Settings.Link.Archive", CDRKey: "ArchiveLink" }),
    ]);

    if (Array.isArray(results[0]) && results[0].length > 0) {
      setRMSLink(results[0][0].ValueString || "");
    }
    if (Array.isArray(results[1]) && results[1].length > 0) {
      setCADLink(results[1][0].ValueString || "");
    }
    if (Array.isArray(results[2]) && results[2].length > 0) {
      setMobileLink(results[2][0].ValueString || "");
    }
    if (Array.isArray(results[3]) && results[3].length > 0) {
      setSettingLink(results[3][0].ValueString || "");
    }
    if (Array.isArray(results[4]) && results[4].length > 0) {
      setAnalyticsLink(results[4][0].ValueString || "");
    }
    if (Array.isArray(results[5]) && results[5].length > 0) {
      setArchiveLink(results[5][0].ValueString || "");
    }
  };

  const StyledBadge = withStyles({
    badge: {
      backgroundColor:
        network.online === false ? "var(--danger)" : "var(--success)",
      color: network.online === false ? "var(--danger)" : "var(--success)",
    },
  })(UserBadge);

  const handleUserMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const closeAbout = () => {
    setDisplayAbout(false);
  };

  const showAbout = () => {
    setDisplayAbout(true);
    handleClose();
  };

  const redirectToTags = () => {
    history.push(`${PATH_TAGS}`);
  };

  const redirectToCodeSettings = () => {
    history.push(`${PATH_CODE_SETTING}`);
  };

  const redirectToCustomIdGenerator = () => {
    history.push(`${PATH_CUSTOM_IDS}`);
  };

  const redirectToSecurity = () => {
    history.push(`${PATH_SECURITY}`);
  };

  const toggleMode = () => {
    setMode();
    handleClose();
  };

  const redirectToApp = (url) => {
    authorizeExternalApp();
    handleClose();
  };

  const handleAppClick = () => {
    setOpenAppSubmenu((prev) => !prev);
  };

  const handleTrainingSubmenuClick = (index) => {
    setOpenTrainingSubmenu((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const reloadLookupCodesAndPermissions = () => {
    dispatch(getDictionaries("ams"));
    dispatch(getUsers());
    dispatch(getUserPermissions());
    dispatch(getPasswordValidation());
    dispatch(getSessionSettings());
    setOpenOptionSubmenu(false);
    handleClose();
  };

  const codeSettingPermission = getAccessPermission("modules", "Codes", "any");
  const codeSettingReadPermission = codeSettingPermission?.Read;

  const securityPermission = getAccessPermission("modules", "Security", "any");
  const securityReadPermission = securityPermission?.Read;

  const renderAgencySelector = () => (
    <FormControl
      variant="outlined"
      size="small"
      style={{ width: 150, color: "white", marginRight: 12 }}
    >
      <InputLabel shrink id="users-agncy">
        Agency
      </InputLabel>
      <Select
        labelId="users-agncy"
        id="party-type"
        label="Agency"
        value={currentUserAgency}
        onChange={changeUserAgency}
        disabled={isInsideEditPage}
        MenuProps={{
          PaperProps: {
            sx: {
              maxHeight: 200,
              overflow: "auto",
            },
          },
        }}
      >
        {agenciesList.data.map((a) => (
          <MenuItem key={a.AgencyID} value={a.AgencyID}>
            {a.AgencyID}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );

  const renderUserMenu = () => {
    return (
      <Menu
        anchorEl={anchorEl}
        keepMounted
        // getContentAnchorEl={null}
        open={Boolean(anchorEl)}
        anchorOrigin={{
          vertical: "center",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "center",
          horizontal: "center",
        }}
        onClose={handleClose}
        className="ml-2"
      >
        <div
          className="dropdown-menu-right dropdown-menu-xxl overflow-hidden p-0"
          sx={{ width: "360px" }}
        >
          <List
            className="text-left bg-transparent flex-column pt-0"
            sx={{ width: "100%", maxWidth: 360, bgcolor: "background.paper" }}
            component="nav"
            aria-labelledby="nested-list-subheader"
            subheader={
              <ListSubheader
                component="div"
                id="nested-list-subheader"
                className="bg-transparent"
              >
                <Box display="flex" flexDirection="column" alignItems="center">
                  <StyledBadge
                    overlap="circular"
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "right",
                    }}
                    variant="dot"
                  >
                    <Avatar sizes="44" alt={userName} className="text-center" />
                  </StyledBadge>
                </Box>
                <div>
                  <div className="font-weight-bold text-center pt-2 line-height-1">
                    {userName}
                  </div>
                </div>
              </ListSubheader>
            }
          >
            <Divider className="w-100 mt-2" />
            <ListItemButton>
              <ListItemIcon>
                {themeMode !== "light" ? <WbSunnyIcon /> : <DarkModeIcon />}
              </ListItemIcon>
              <ListItemText
                primary={themeMode !== "light" ? "Light Mode" : "Dark Mode"}
              />
              <Switch checked={themeMode !== "light"} onChange={toggleMode} />
            </ListItemButton>
            {(canReadCadPermission ||
              canReadRMSPermission ||
              canReadMobilePermission ||
              canReadAnalyticsPermission ||
              canReadSetingsPermission ||
              canReadArchivePermission) && (
              <>
                <ListItemButton onClick={handleAppClick}>
                  <ListItemIcon>
                    <AppsIcon />
                  </ListItemIcon>
                  <ListItemText primary="Application" />
                  {openAppSubmenu ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
                <Collapse in={openAppSubmenu} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    {canReadAnalyticsPermission && (
                      <ListItemButton
                        sx={{ pl: 5 }}
                        component="a"
                        href={analyticsLink}
                        target="_settings"
                        onClick={() => redirectToApp(analyticsLink)}
                        disabled={!analyticsLink}
                      >
                        <ListItemIcon>
                          <img
                            src={IconAnalytics}
                            alt="Analytics icon"
                            style={{ width: 24, height: 24 }}
                          />
                        </ListItemIcon>
                        <ListItemText primary="Analytics" />
                      </ListItemButton>
                    )}
                    {canReadArchivePermission && (
                      <ListItemButton
                        sx={{ pl: 5 }}
                        component="a"
                        href={archiveLink}
                        target="_settings"
                        onClick={() => redirectToApp(archiveLink)}
                        disabled={!archiveLink}
                      >
                        <ListItemIcon>
                          <img
                            src={IconArchive}
                            alt="Archive icon"
                            style={{ width: 24, height: 24 }}
                          />
                        </ListItemIcon>
                        <ListItemText primary="Archive Browser" />
                      </ListItemButton>
                    )}
                    {canReadCadPermission && (
                      <ListItemButton
                        sx={{ pl: 5 }}
                        button
                        component="a"
                        href={cadLink}
                        target="_settings"
                        onClick={() => redirectToApp(cadLink)}
                        disabled={!cadLink}
                      >
                        <ListItemIcon>
                          <img
                            src={IconCad}
                            alt="CAD icon"
                            style={{ width: 24, height: 24 }}
                          />
                        </ListItemIcon>
                        <ListItemText primary="CAD" />
                      </ListItemButton>
                    )}
                    {canReadMobilePermission && (
                      <ListItemButton
                        sx={{ pl: 5 }}
                        component="a"
                        href={mobileLink}
                        target="_settings"
                        onClick={() => redirectToApp(mobileLink)}
                        disabled={!mobileLink}
                      >
                        <ListItemIcon>
                          <img
                            src={IconMobile}
                            alt="MOBILE icon"
                            style={{ width: 24, height: 24 }}
                          />
                        </ListItemIcon>
                        <ListItemText primary="Mobile" />
                      </ListItemButton>
                    )}
                    {canReadRMSPermission && (
                      <ListItemButton
                        sx={{ pl: 5 }}
                        button
                        component="a"
                        href={rmsLink}
                        target="_settings"
                        onClick={() => redirectToApp(rmsLink)}
                        disabled={!rmsLink}
                      >
                        <ListItemIcon>
                          <img
                            src={iconRms}
                            alt="MOBILE icon"
                            style={{ width: 24, height: 24 }}
                          />
                        </ListItemIcon>
                        <ListItemText primary="RMS" />
                      </ListItemButton>
                    )}

                    {canReadSetingsPermission && (
                      <ListItemButton
                        sx={{ pl: 5 }}
                        component="a"
                        href={settingLink}
                        target="_settings"
                        onClick={() => redirectToApp(settingLink)}
                        disabled={!settingLink}
                      >
                        <ListItemIcon>
                          <img
                            src={IconSetting}
                            alt="Setting icon"
                            style={{ width: 24, height: 24 }}
                          />
                        </ListItemIcon>
                        <ListItemText primary="Settings" />
                      </ListItemButton>
                    )}
                  </List>
                </Collapse>
              </>
            )}
            <ListItemButton onClick={handleOptionClick}>
              <ListItemIcon>
                <TuneIcon />
              </ListItemIcon>
              <ListItemText primary="Options" />
              {openOptionSubmenu ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={openOptionSubmenu} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {codeSettingReadPermission && (
                  <ListItemButton
                    onClick={redirectToCodeSettings}
                    sx={{ pl: 5 }}
                  >
                    <ListItemIcon>
                      <Category />
                    </ListItemIcon>
                    <ListItemText primary="Code Settings" />
                  </ListItemButton>
                )}
                <ListItemButton
                  onClick={redirectToCustomIdGenerator}
                  sx={{ pl: 5 }}
                >
                  <ListItemIcon>
                    <SettingsSuggest />
                  </ListItemIcon>
                  <ListItemText primary="Custom ID Settings" />
                </ListItemButton>
                <ListItemButton onClick={redirectToTags} sx={{ pl: 5 }}>
                  <ListItemIcon>
                    <LocalOffer />
                  </ListItemIcon>
                  <ListItemText primary="Manage Tags" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 5 }}
                  onClick={reloadLookupCodesAndPermissions}
                  button
                >
                  <ListItemIcon>
                    <RestartAltIcon />
                  </ListItemIcon>
                  <ListItemText primary="Reload Codes & Permissions" />
                </ListItemButton>
                {securityReadPermission && (
                  <ListItemButton onClick={redirectToSecurity} sx={{ pl: 5 }}>
                    <ListItemIcon>
                      <SecurityIcon />
                    </ListItemIcon>
                    <ListItemText primary="Security" />
                  </ListItemButton>
                )}

                {/* <ListItemButton
                    sx={{ pl: 5 }}
                    onClick={showChangePass}
                    button
                  >
                    <ListItemIcon>
                      <KeyIcon />
                    </ListItemIcon>
                    <ListItemText primary="Change Password" />
                  </ListItemButton> */}
                {/* <ListItemButton
                    sx={{ pl: 5 }}
                    onClick={handleClearCache}
                    button
                  >
                    <ListItemIcon>
                      <DeleteSweepIcon />
                    </ListItemIcon>
                    <ListItemText primary="Clear Cache" />
                  </ListItemButton> */}
              </List>
            </Collapse>

            {/* <ListItemButton
                onClick={handleOpenSettings}
                button
                component="a"
                href={trainingLink}
                target="_settings"
                disabled={!trainingLink}
              >
                <ListItemIcon>
                  <SchoolIcon />
                </ListItemIcon>
                <ListItemText primary="Training Academy" />
              </ListItemButton> */}
            {/* <ListItemButton
                onClick={handleOpenSettings}
                button
                component="a"
                href={helpLink}
                target="_settings"
                disabled={!helpLink}
              >
                <ListItemIcon>
                  <HelpOutlineIcon />
                </ListItemIcon>
                <ListItemText primary="Help" />
              </ListItemButton> */}

            <ListItemButton onClick={showAbout}>
              <ListItemIcon>
                <InfoIcon />
              </ListItemIcon>
              <ListItemText primary="About" />
            </ListItemButton>

            <Divider className="w-100" />
            <ListItem className="d-block rounded-bottom px-3 pt-3 pb-0 text-center">
              <Button
                onClick={() => setUserAuthenticated(false)}
                variant="outlined"
                size="large"
                color="inherit"
              >
                <span className="btn-wrapper--icon">
                  <FontAwesomeIcon icon={["fas", "sign-out-alt"]} />
                </span>
                <span className="btn-wrapper--label">Logout</span>
              </Button>
            </ListItem>
          </List>
        </div>
      </Menu>
    );
  };

  const handleLeftDrawerItemClick = () => {
    setNavigationDrawerMobileState();
  };

	const leftDrawerList = () => {
		const hasRead = (item) => {
			if (item.alwaysVisible) return true;

			if (
				!item.permission ||
				!item.permission.area ||
				!item.permission.key
			) {
				return false;
			}

			const permObj = getAccessPermission(
				item.permission.area,
				item.permission.key,
				userAgency,
			);
			return !!permObj?.Read;
		};

		const allowedMenu = menuItems
			.map((item) => {
				if (item.subMenu) {
					const filteredSub = item.subMenu.filter((s) => hasRead(s));
					const parentAllowed = hasRead(item);
					return parentAllowed
						? { ...item, subMenu: filteredSub }
						: null;
				} else {
					return hasRead(item) ? item : null;
				}
			})
			.filter(Boolean);

		return (
			<Fragment>
				<div
					className="app-sidebar-header"
					style={{
						width: "220px",
						height: "80px",
						background: "transparent",
						borderBottom: "5px",
					}}
				>
					<Box className="header-logo-wrapper" title="AMS">
						<Link
							to={PATH_HOME}
							className="header-logo-wrapper-link"
						>
							<IconButton
								color="primary"
								size="medium"
								style={{ background: "transparent" }}
								className="header-logo-wrapper-btn"
							>
								<img
									className="app-sidebar-logo"
									alt=""
									src={IconAms}
								/>
							</IconButton>
						</Link>
						<Box
							className={classes.logoText}
							style={{
								fontWeight: "bold",
								fontSize: "1.1rem",
								color: theme.palette.colors.label,
							}}
						>
							AMS
						</Box>
					</Box>

					<Box className="app-sidebar-header-btn">
						<Tooltip title="Toggle Navigation" placement="right">
							<IconButton
								style={{ color: theme.palette.colors.label }}
								onClick={() => setNavigationDrawerMobileState()}
								size="medium"
							>
								<MenuOpenRoundedIcon />
							</IconButton>
						</Tooltip>
					</Box>

					<Box className="app-sidebar-header-btn-mobile">
						<Tooltip title="Toggle Navigation" placement="right">
							<IconButton
								style={{ color: theme.palette.colors.label }}
								onClick={() => setNavigationDrawerMobileState()}
								size="medium"
							>
								<MenuOpenRoundedIcon />
							</IconButton>
						</Tooltip>
					</Box>
				</div>

				<Divider />

				<div>
					<Box sx={{ width: 200 }} role="presentation">
						{allowedMenu.map((btn, idx) => {
							return btn.subMenu ? (
								<>
									<Tooltip
										title={btn.tooltip}
										key={idx}
										className={classes.drawerItems}
										style={{ padding: "0px 0px" }}
									>
										<ListItemButton
											onClick={() =>
												handleTrainingSubmenuClick(idx)
											}
											className={classes.drawerItemsBtn}
											sx={{
												padding: "8px 16px !important",
											}}
										>
											{btn.label}
											{openTrainingSubmenu[idx] ? (
												<ExpandLess />
											) : (
												<ExpandMore />
											)}
										</ListItemButton>
									</Tooltip>
									<Collapse
										in={openTrainingSubmenu[idx]}
										timeout="auto"
										unmountOnExit
									>
										<List component="div" disablePadding>
											{btn.subMenu.map(
												(subItem, subIdx) => (
													<Tooltip
														title={subItem.tooltip}
														key={subIdx}
														className={
															classes.drawerItems
														}
														style={{
															padding: "0px 0px",
														}}
													>
														<ListItemButton
															sx={{
																paddingLeft:
																	"1.5rem !important",
															}}
															component={NavBase}
															to={subItem.link}
															className={
																classes.subMenuListItemActive
															}
															onClick={
																handleLeftDrawerItemClick
															}
															key={subIdx}
														>
															<CircleIcon
																className={
																	classes.propertyItemIcon
																}
															/>
															<ListItemText
																primary={
																	subItem.label
																}
																className={
																	classes.propertyItemLabel
																}
															/>
														</ListItemButton>
													</Tooltip>
												),
											)}
										</List>
									</Collapse>
								</>
							) : (
								<Tooltip
									title={btn.tooltip}
									key={idx}
									className={classes.drawerItems}
									style={{ padding: "0px 0px" }}
								>
									<NavLink to={btn.link}>
										<ListItemButton
											onClick={handleLeftDrawerItemClick}
											className={classes.drawerItemsBtn}
										>
											{btn.label}
										</ListItemButton>
									</NavLink>
								</Tooltip>
							);
						})}
					</Box>
				</div>
			</Fragment>
		);
	};

	const renderMobileMenu = () => {
		return (
			<div
				style={{
					display: "flex",
					alignSelf: "center",
					justifyContent: "space-between",
					width: "100%",
				}}
			>
				<div style={{ alignSelf: "center" }}>
					<IconButton
						color="inherit"
						aria-label="Open drawer"
						edge="start"
						onClick={() => setNavigationDrawerMobileState()}
					>
						<MenuIcon
							style={{ color: theme.palette.colors.label }}
						/>
					</IconButton>
					<Drawer
						variant="temporary"
						anchor="left"
						open={navigationDrawerMobileState}
						onClose={() => setNavigationDrawerMobileState()}
						classes={{
							paper: classes.drawerPaper,
						}}
						ModalProps={{
							keepMounted: true, // Better open performance on mobile.
						}}
					>
						{leftDrawerList()}
					</Drawer>
				</div>
				<div style={{ display: "flex" }}>
					<div style={{ alignSelf: "center" }}>
						<Button
							color="inherit"
							onClick={handleUserMenuClick}
							className="px-3 text-left btn-inverse d-flex align-items-center"
						>
							{agenciesList?.data?.length > 0 &&
								renderAgencySelector()}
							<Box>
								<StyledBadge
									overlap="circular"
									anchorOrigin={{
										vertical: "bottom",
										horizontal: "right",
									}}
									variant="dot"
								>
									<Avatar sizes="44" alt={userName} />
								</StyledBadge>
							</Box>
							<span
								className="pl-2 pl-xl-3 d-flex"
								style={{
									color: theme.palette.colors.label,
									alignItems: "center",
								}}
							>
								<span
									style={{
										paddingRight: "8px",
										textDecoration: "none",
									}}
								>
									{userName}
								</span>
								<FontAwesomeIcon
									icon={["fas", "angle-down"]}
									className="opacity-5"
								/>
							</span>
						</Button>
					</div>
				</div>
			</div>
		);
	};

  const renderDesktopMenu = () => {
    const hasRead = (item) => {
      if (item.alwaysVisible) return true;

      if (!item.permission || !item.permission.area || !item.permission.key) {
        return false;
      }

      const permObj = getAccessPermission(
        item.permission.area,
        item.permission.key,
        userAgency
      );
      return !!permObj?.Read;
    };

    const allowedMenu = menuItems
      .map((item) => {
          return hasRead(item) ? item : null;
      })
      .filter(Boolean);

    return (
      <div className={classes.wrapper}>
        <div className={classes.leftMenu}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div className={classes.logo} />
          </div>
          {allowedMenu.map((btn, idx) => {
            const isActive = btn.subMenu
              ? btn.subMenu.some((subItem) =>
                  location.pathname.startsWith(subItem.link)
                )
              : location.pathname === btn.link;
            return (
              <Tooltip
                title={btn.tooltip}
                key={idx}
                className={classes.items}
                style={{ padding: "10px 10px" }}
              >
                  <ListItemButton
                    sx={{ flexGrow: "0 !important" }}
                    to={btn.link}
                    component={NavBase}
                    className={
                      isActive
                        ? `${classes.listItemActive} active`
                        : classes.listItemActive
                    }
                  >
                    <Grid container direction="column" alignItems="center">
                      <Grid item xs={12}>
                        <FontAwesomeIcon
                          icon={btn.icon}
                          className="font-size-xl"
                        />
                      </Grid>
                      <Grid item xs={12}>
                        {btn.label}
                      </Grid>
                    </Grid>
                  </ListItemButton>
              </Tooltip>
            );
          })}
        </div>
        <div className={classes.rightMenu}>
          {agenciesList?.data?.length > 0 && renderAgencySelector()}
          <Button
            onClick={handleUserMenuClick}
            className="px-3 text-left btn-inverse d-flex align-items-center"
          >
            <Box className={classes.avatar} style={{ display: "flex" }}>
              <div>
                <StyledBadge
                  overlap="circular"
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                  }}
                  variant="dot"
                >
                  <Avatar sizes="44" alt={userName} />
                </StyledBadge>
              </div>
            </Box>
            {windowWidth <= 1335 && (
              <span
                className="pl-2 pl-xl-3 d-flex"
                style={{ color: theme.palette.colors.label }}
              >
                <FontAwesomeIcon
                  icon={["fas", "angle-down"]}
                  className="opacity-5"
                />
              </span>
            )}
            {windowWidth > 1335 && (
              <span
                className="pl-2 pl-xl-3 d-flex"
                style={{
                  color: theme.palette.colors.label,
                  alignItems: "center",
                }}
              >
                <span
                  style={{ paddingRight: "8px", textDecoration: "none" }}
                  className={classes.outlined}
                >
                  {userName}
                </span>
                <FontAwesomeIcon
                  icon={["fas", "angle-down"]}
                  className="opacity-5"
                />
              </span>
            )}
          </Button>
        </div>
      </div>
    );
  };

  return (
    <Fragment>
      <AppBar color="primary" position="fixed" className={classes.appBar}>
        <Toolbar className={classes.toolbar}>
          {/* {isDesktop && renderDesktopMenu()} */}
          {isMobile ? renderMobileMenu() : renderDesktopMenu()}
          {renderUserMenu()}
        </Toolbar>
      </AppBar>
      {/* {searchMenuVisible && (
        <div className={classes.fwMenuWrap} onClick={() => setSearchMenuVisible(false)}>
          <Card className={classes.fullWidthMenu}>{renderSearchMenu()}</Card>
      {propertyMenuVisible && (
        <div className={classes.fwMenuWrap} onClick={() => setPropertyMenuVisible(false)}>
          <Card className={classes.fullWidthMenu}>{renderPropertiesMenu()}</Card>
        </div>
      )} */}
      <div style={{ position: "relative" }}>
        {/* {openPeopleSearchMenuDesktop && (
          <div
            className={classes.peopleMenuWrap}
            onClick={() => setOpenPeopleSearchMenuDesktop(false)}>
            <Card>{renderPeopleMenu()}</Card>
          </div>
        )}
        {locationsMenuVisible && (
          <div className={classes.locationsMenuWrap} onClick={() => setLocationsMenuVisible(false)}>
            <Card>{renderLocationsMenu()}</Card>
          </div>
        )} */}
        {/* {searchMenuVisible && (
          <div
            className={classes.fwMenuWrap}
            onClick={() => setSearchMenuVisible(false)}
          >
            <Card className={classes.fullWidthMenu}>{renderSearchMenu()}</Card>
          </div>
        )} */}
      </div>

      {displayAbout && <AboutDialog close={closeAbout} />}
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  user: state.user,
  network: state.offline,
  themeMode: state.theme.mode,
  navigationDrawerMobileState: state.ui.navigationDrawerMobileState,
  agencies: state.ptsAgencies?.agencies,
  wsClient: state.websocket.websocket,
});

export default connect(mapStateToProps, {
  setMode,
  setUserAuthenticated,
  setNavigationDrawerMobileState,
  setUserAgency,
})(TopBar);
